
import request from "../utils/request";

var user = '/user'
var resource= '/resource'

// 行为验证初始化
export function initValidation(data) {
  return request({
    url: user + `/validation/behavior-init`,
    method: 'get',
    data
  })
}

// 行为验证校验
export function verifyValidation(data) {
  return request({
    url: user + '/validation/behavior-verify',
    method: 'post',
    data
  })
}

// 行为验证校验 2.0（第四代极验）
export function verifyValidationV2(data) {
  return request({
    url: user + '/validation/v2/behavior-verify',
    method: 'post',
    data
  })
}

// 获取用户基本信息
export function getUserInfo() {
  return request({
    url: user + '/user/base',
    method: 'get',
  })
}


// 获取下载版本信息
export function versionsApi() {
  return request({
    url: resource+'/versions/web',
    method: 'get'
  })
}

// 注册/忘记密码  获取验证码
export function sendCode(type, data) {
  return request({
    url: user + '/validation' + (type == 'phone' ? '/sms' : '/email'),
    method: 'post',
    headers: {'Content-Type': 'application/json; charset=UTF-8'},
    data,
  })
}

// 登录获取验证码
export function loginSendCode(type, data) {
  return request({
    url: user + '/validation/limit' + (type == 'phone' ? '/sms' : '/email'),
    method: 'get',
    data,
  })
}

// 绑定--获取验证码
export function bindSendCode(type, data) {
  return request({
    url: user + '/validation/binding' + (type == 'phone' ? '/sms' : '/email'),
    method: 'get',
    data,
  })
}

//在线--获取验证码（当次数大于两次调用极限验证）
export function onlineSendCode(type, data) {
  return request({
    url: user + '/validation/online' + (type == 'phone' ? '/sms' : '/email'),
    method: 'post',
    headers: {'Content-Type': 'application/json; charset=UTF-8'},
    data,
  })
}

// 注册
export function register(data) {
  return request({
    url: user + '/register',
    method: 'post',
    headers: {'Content-Type': 'application/json; charset=UTF-8'},
    data
  })
}

// 登录
export function loginApi(data) {
  return request({
    url: user + '/login',
    method: 'post',
    headers: {'Content-Type': 'application/json; charset=UTF-8'},
    data
  })
}

// 退出登录
export function loginOut() {
  return request({
    url: user + '/logout',
    method: 'post'
  })
}

// 获取返佣基础信息
export function getDomain() {
  return request({
    url: user + '/invite/info',
    method: 'get'
  })
}


export function getCountryList() {
  return request({
    url: user + '/config/areas',
    method: 'get',
  })
}

export function getLanguageList() {
  return request({
    url: user + '/config/languages',
    method: 'get',
  })
}

// 获取裂变域名
export function getDomains() {
  return request({
    url: user + '/invite/domains',
    method: 'get',
  })
}

export function getCodesTion () {
  return request({
    url: `/broker/v3/invitation/codes/default`,
    method: 'get',
    // data,
    // headers: { 'Content-Type': 'application/json; charset=UTF-8' },
  })
}

export function getUserYearReport(){
  return request({
    url: user+'/v3/bigdata/annual-report/query',
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js